import React, { Component } from "react";
import ReactGA from "react-ga";

import styled from "styled-components";
import { connect } from "react-redux";

import TableBlock from "./blocks/TableBlock";
import TextBlock from "./blocks/TextBlock";
import ReactCodeBlock from "./blocks/ReactCodeBlock";
import HtmlCodeBlock from "./blocks/HtmlCodeBlock";
import HtmlWithCssCodeBlock from "./blocks/HtmlWithCssCodeBlock";
import CodepenBlock from "./blocks/CodepenBlock";
import ChapterFooter from "./ChapterFooter";
import CodeSandbox from "./blocks/CodeSandbox";
import CodeBlock from "./blocks/CodeBlock";

import { Button } from "../base/Buttons";

import Codecamps from "./Codecamps";

import { doSetBook, doSetPositionInChapter } from "../redux/reducers";
import { saveBookInLocalStorage, getBookFromLocalStorage } from "./utils";

const Wrapper = styled.div`
  padding: 0 ${props => props.theme.outerMargin};
  max-width: 1200px;
  margin: 0 auto;
`;

const BookWrapper = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 120px;
  margin-bottom: 40px;
  border-radius: ${props => props.theme.radius.xs};
  background: #f8f8f8;
  padding: 120px 40px;
  overflow-y: scroll;
`;

// For scrolling has stopped
// let isScrolling = null;

class Book extends Component {
  // state = {
  //   initialScroll: false // should be set to true if launched or if user changed chapter, but not when he just scrolls
  // };

  componentDidMount() {
    ReactGA.initialize("UA-8858797-14");
    ReactGA.pageview("/tutorial");

    const { onSetBook } = this.props;
    const book = getBookFromLocalStorage();

    // put the book from local storage to redux
    if (!!book) onSetBook(book);
  }

  // onResetBook = () => {
  //   localStorage.removeItem("makers.book");
  //   const book = getBookFromLocalStorage();
  //   if (!!book) this.props.onSetBook(book);
  // };

  // componentDidUpdate(prevProps) {
  //   const { prevBook } = prevProps;
  // }

  componentWillUpdate(nextProps) {
    if (this.props.activeChapterId !== nextProps.activeChapterId) {
      window.scrollTo(0, 0);
    }
  }

  componentWillUnmount() {
    document.removeEventListener("scroll", this.onScroll);
  }

  // onInitialScroll = () => this.setState({ initialScroll: true });

  // scrollToLastPosition = book => {
  //   const chapter = book.chapters[book.activeChapterId];
  //   const { block, position } = chapter;
  //
  //   // if position is not null (code block) find the element and scroll to it
  //   if (!!position) {
  //     const element = document.querySelector(`[data-sourcepos='${position}']`);
  //
  //     if (element) {
  //       element.scrollIntoView({
  //         behavior: "smooth",
  //         block: "start",
  //         inline: "nearest"
  //       });
  //       this.onInitialScroll();
  //     }
  //   } else {
  //     if (!!block || block >= 0) {
  //       const element = document.querySelectorAll(
  //         `[data-blocknumber='block${block}']`
  //       )[0];
  //
  //       if (!!element) {
  //         element.scrollIntoView({
  //           behavior: "smooth",
  //           block: "end",
  //           inline: "nearest"
  //         });
  //         this.onInitialScroll();
  //       }
  //     }
  //   }
  // };

  // onScrollStop = () => {
  //   const blocks = document.getElementsByClassName("block");
  //   const blocksArray = Array.prototype.slice.call(blocks); // change html collection => array
  //
  //   // if block is long and it's start scrolled outside of the view, heck if it's end is visible and still assign it's number
  //   // for short blocks chose if the top of the block is visible and assign the number
  //   const firstVisibleId =
  //     blocksArray.findIndex(
  //       block => block.offsetTop > window.pageYOffset + 80
  //     ) === -1
  //       ? blocksArray.findIndex(
  //           block =>
  //             block.offsetTop + block.offsetHeight > window.pageYOffset + 80
  //         )
  //       : blocksArray.findIndex(
  //           block => block.offsetTop > window.pageYOffset + 80
  //         );
  //
  //   // Find all data-sourcepos elements
  //   const nodesWithPosition = blocksArray[firstVisibleId].querySelectorAll(
  //     "[data-sourcepos]"
  //   );
  //   const elementsWithPosition = Array.prototype.slice.call(nodesWithPosition); // change html collection => array
  //
  //   // text elements will have data-sourcepos, code elements not so an array will be empty
  //   const elementWithPositionInView = elementsWithPosition.length
  //     ? elementsWithPosition.find(
  //         element => element.offsetTop > window.pageYOffset + 80
  //       )
  //     : null;
  //
  //   // position is 0 for code-elements
  //   const elementPosition = !!elementWithPositionInView
  //     ? elementWithPositionInView.dataset.sourcepos
  //     : 0;
  //   const { onSetPosition, activeChapterId } = this.props;
  //
  //   onSetPosition(activeChapterId, firstVisibleId, elementPosition);
  //   saveBookInLocalStorage(this.props.book);
  // };

  // onScroll = () => {
  //   // Set a timeout to run onScrollStop when scrolling ends
  //   window.clearTimeout(isScrolling);
  //   isScrolling = setTimeout(() => {
  //     this.onScrollStop();
  //   }, 500);
  // };

  getBlock = (item, blockNumber) => {
    const { activeChapterId } = this.props;
    switch (item.type) {
      case "TEXT":
      case "COMMANDS":
        return <TextBlock text={item.text} blockNumber={blockNumber} />;
      case "TABLE":
        return <TableBlock table={item} blockNumber={blockNumber} />;
      case "CODEPEN":
        return (
          <CodepenBlock
            hash={item.hash}
            blockNumber={blockNumber}
            activeChapterId={activeChapterId}
          />
        );
      case "CODE_SANDBOX":
        return (
          <CodeSandbox
            hash={item.hash}
            blockNumber={blockNumber}
            activeChapterId={activeChapterId}
          />
        );
      case "REACT":
        return (
          <ReactCodeBlock
            codeUser={item.reactCodeUser}
            blockNumber={blockNumber}
            activeChapterId={activeChapterId}
            codeId={item.id}
          />
          // <ReactSandbox hash="9jnyx4zkyp" />
        );
      case "HTML":
        return (
          <HtmlCodeBlock
            codeUser={item.htmlCodeUser}
            blockNumber={blockNumber}
            activeChapterId={activeChapterId}
            codeId={item.id}
          />
        );
      case "HTML_WITH_CSS":
        return (
          <HtmlWithCssCodeBlock
            codeUser={item.htmlCodeUser}
            cssUser={item.cssCodeUser}
            blockNumber={blockNumber}
            activeChapterId={activeChapterId}
            codeId={item.id}
          />
        );
      case "PLAIN_JAVASCRIPT":
        return <CodeBlock code={item.code} language="javascript" />;
      case "PLAIN_JSX":
        return <CodeBlock code={item.code} language="jsx" />;
      case "PLAIN_HTML":
        return <CodeBlock code={item.code} language="html" />;
      case "PLAIN_CSS":
        return <CodeBlock code={item.code} language="css" />;
      default:
        return null;
    }
  };

  render() {
    const { book, activeChapterId } = this.props;
    const titles = !!book ? book.chapters.map(chapter => chapter.title) : [];
    const chapterBlocks = !!book
      ? book.chapters[activeChapterId].content
      : null;

    // On every change of props, even on the change of the location
    // the elements rerenders unnecessarily

    return (
      <Wrapper onScroll={this.onScroll}>
        <BookWrapper>
          {/* <Button onClick={this.onResetBook} color="#aa5500">
            Reset book
          </Button> */}
          {!!book &&
            chapterBlocks instanceof Array &&
            chapterBlocks.map((item, index) => (
              <div key={item.id} id="chapter">
                {this.getBlock(item, `block${index}`)}
              </div>
            ))}

          <Codecamps />

          {!!titles && (
            <ChapterFooter activeChapterId={activeChapterId} titles={titles} />
          )}
        </BookWrapper>
      </Wrapper>
    );
  }
}

const mapStateToProps = state => ({
  book: state.book,
  activeChapterId: !!state.book ? state.book.activeChapterId : 0
});

const mapDispatchToProps = dispatch => ({
  onSetPosition: (chapter, block, position) =>
    dispatch(doSetPositionInChapter(chapter, block, position)),
  onSetBook: book => dispatch(doSetBook(book))
});

export default connect(mapStateToProps, mapDispatchToProps)(Book);



// WEBPACK FOOTER //
// ./src/book/Book.js